export default __webpack_public_path__ + "static/cards-dark-b89c7d15167cf9669fd7f0b4e2d0ccc7.png";